export const collection = 'cms_category_level2';
